import { Space, Typography } from "antd";
import type { ReactNode } from "react";
import { useIsMobile } from "../useIsMobile";

export function PageHead({ title, sub, extra }: { title: ReactNode; sub?: ReactNode; extra?: ReactNode }) {
  const mobile = useIsMobile();
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
      <div style={{ minWidth: 0, maxWidth: "100%" }}>
        <Typography.Title level={mobile ? 4 : 3} style={{ margin: 0, overflowWrap: "anywhere" }}>
          {title}
        </Typography.Title>
        {sub ? <div style={{ marginTop: 4 }}>{sub}</div> : null}
      </div>
      {mobile ? <div style={{ width: "100%" }}>{extra}</div> : <Space wrap>{extra}</Space>}
    </div>
  );
}
